import template from "./support-center-content.html";
import "./support-center-content.less";
import markdownToHtmlModule from "../markdown-viewer";

export function controller(agreementService, $uibModal) {
	const ctrl = this;

	ctrl.canShowAgreements = agreementService.agreements?.length > 0;

	ctrl.showAgreementsModal = () => {
		$uibModal.open({
			component: "show-agreements-modal",
			size: "lg",
			backdrop: "static",
			keyboard: false
		});
	};
}

export default angular
	.module("vesl.components.support-center-content", [markdownToHtmlModule])
	.component("supportCenterContent", {
		template,
		controller,
		bindings: {
			form: "<",
			support: "<",
			supportMarkdown: "<",
			userProfile: "<",
			hotkeys: "<",
			onPrivacyClick: "&",
			onSupportAndFeedbackClick: "&",
			onTermsClick: "&",
			canViewVeslFeedback: "<",
			canViewAgencyFeedback: "<",
			canViewAgencyPhoneNumber: "<",
			canViewAgencyEmail: "<",
			canViewAgencyMarkdown: "<"
		}
	}).name;
